import {login, logout, getInfo, loginByPhoneCode,emailPasswordLogin,phoneCaptchaLogin} from '@/api/login'
import {getToken, setToken, removeToken} from '@/utils/auth'
import axios from "axios";
import i18n from "@/lang";

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    icon: '',
    email: '',
    roles: [],
    userId: null,
    roleTypeList: [],
    phone: null,
    menus: [],
    localInfo: {},
    code: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_ROLETYPELIST: (state, roleTypeList) => {
      state.roleTypeList = roleTypeList
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_LOCALINFO: (state, localInfo) => {
      state.localInfo = localInfo
    },
    SET_ICON: (state, icon) => {
      state.icon = icon
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
  },

  actions: {
    setToken({commit}, data) {
      commit('SET_TOKEN', data)
    },
    // 登录
    Login({commit}, userInfo) {
      const username = userInfo.username.trim()
      let params = {
        email: username,
        password: userInfo.password,
        code: userInfo.code,
        imageKey: userInfo.imageKey,
      }
      return new Promise((resolve, reject) => {
        emailPasswordLogin(params).then(response => {
          const data = response
          if (response.code === 200) {
            const tokenStr = data.data.tokenHead + data.data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    phoneLogin({commit}, phoneInfo) {
      return new Promise((resolve, reject) => {
        const username = phoneInfo.username.trim()
        let params = {
          phone: username,
          phoneCode: phoneInfo.phoneCode,
          code: phoneInfo.code
        }
        phoneCaptchaLogin(params).then((res) => {
          if (res.code === 200) {
            let tokenStr = res.data.tokenHead + res.data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({commit}) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          if (!response) return false
          const data = response.data
          const roleList = data.permission.roleIdList
          const menuList = data.permission.menus || []
          if (roleList && roleList.length > 0) { // 验证返回的roles是否是一个非空数组
            // (userType !== 1) || 没有可访问的菜单 拒绝登录
            if (menuList.length === 0) {
              commit('SET_TOKEN', '')
              reject(i18n.t('system.noPermission'))
            } else {
              commit('SET_ROLES', roleList)
            }
          } else {
            commit('SET_TOKEN', '')
            reject(i18n.t('system.noPermission'))
          }
          if(data.username) {
            commit('SET_NAME', data.username)
          } else {
            commit('SET_NAME', '+' + data.phoneAreaCode + '\t' + data.phone)
          }
          commit('SET_AVATAR', data.icon)
          commit('SET_ICON', data.icon)
          commit('SET_EMAIL', data.email)
          commit('SET_USERID', data.id)
          localStorage.setItem('admin-userId', data.id)
          commit('SET_PHONE', data.phone)
          commit('SET_MENUS', menuList ? menuList : [])
          commit('SET_CODE', data.code)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户的本地 IP
    GetLocalIP({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        // 默认值GB
        const fallbackData = {
          country: 'GB',
          city: 'London'
        }
        // 设置请求超时时间（5秒）
        const timeout = 5000;
        const source = axios.CancelToken.source();
        const timeoutId = setTimeout(() => {
          source.cancel('Request timeout');
        }, timeout);

        axios.get('https://ipinfo.io/json', {
          cancelToken: source.token
        }).then(response => {
          clearTimeout(timeoutId);
          // 响应非200
          if (!response || response.status !== 200) {
            commit('SET_LOCALINFO', fallbackData);
            resolve(fallbackData);
            return;
          }

          const data = response.data
          // 验证响应数据是否有效
          if (!data || typeof data !== 'object') {
            console.log('Invalid response format from IP API');
            commit('SET_LOCALINFO', fallbackData);
            resolve(fallbackData);
            return;
          }
          // 确保国家代码存在，否则使用默认值GB
          const processedData = {
            ...data,
            country: data.country || 'GB',
            city: data.city || 'London'
          };
          commit('SET_LOCALINFO', processedData);
          resolve(processedData)
        }).catch(() => {
          clearTimeout(timeoutId);
          console.log(i18n.t('system.noIp'))
          commit('SET_LOCALINFO', fallbackData);
          resolve(fallbackData);
        });
      })
    },

    // 登出
    LogOut({commit, state}) {
      return logout(state.token).catch(() => {
        // 账号被禁用或 token 失效时，退出接口也可能返回 401。
        // 忽略接口异常，继续清除本地登录状态。
      }).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        localStorage.setItem('admin-userId', '')
        removeToken()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js